/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel2";
import Query from "components/Query";
import "react-owl-carousel2/lib/styles.css";
import { useHistory } from "react-router-dom";
import useWindowWidth from "components/UseWindowWidth";
// import LazyLoadImage from 'components/LazyLoadImage'
const BASE_URL = process.env.REACT_APP_BASE_URL;

const VideoSlider = ({ onClickModal }) => {

  const history = useHistory();

  const width = useWindowWidth();

  const carouselOptions = {
    items: 2.5,
    loop: true,
    margin: 5,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    navText: [
      '<img src="/img/arrow-button-left.svg" id="custom-prev">',
      '<img src="/img/arrow-button-right.svg" id="custom-next">'
    ],
  };

  const [buttonId, setButtonId] = useState();

  const handleMouseEnter = (id) => {
    setButtonId(id);
  };

  const handleMouseLeave = () => {
    setButtonId("");
  };

  useEffect(() => {
    const handleResize = () => {
      if (width < 768) {
        // On mobile screens, display 2 items
        carouselOptions.items = 1.3;
      } else {
        // On larger screens (desktop), display 5 items
        carouselOptions.items = 2.5;
      }
    };

    // Initial setup
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    // <div className="all-video-slider-wrapper wow fadeInUp">
    //   <Query url={BASE_URL + "/api/videos"}>
    //     {({ data }) => (
    //       <OwlCarousel
    //         options={carouselOptions}
    //         className="owl-carousel owl-theme all-video-slider nav-middle"
    //       >
    //         {data.map((i) => (
    //           <div key={i._id} className="item">
    //             <div
    //               role="presentation"
    //               onClick={() => onClickModal(i.videoId)}
    //               className="all-videos-wrapper"
    //             >
    //               <div
    //                 className="video-play-wrapper"
    //                 style={{ position: "relative" }}
    //               >
    //                 <img
    //                   className="lazy"
    //                   // overlaySrc={`https://img.youtube.com/vi/${i.videoId}/2.jpg`}
    //                   src={`https://img.youtube.com/vi/${i.videoId}/0.jpg`}
    //                   alt={i.title}
    //                 />
    //                 <span className="video-play-overlay">
    //                   <img
    //                     src="/resources/img/sabinehospital-icons/sabinehospital-video-icon.png"
    //                     style={{ width: "auto" }}
    //                     alt=""
    //                   />
    //                 </span>
    //               </div>
    //             </div>
    //           </div>
    //         ))}
    //       </OwlCarousel>
    //     )}
    //   </Query>
    // </div>
    <>
      <div className="video-of-flex wow bounceInLeft">
        <img className="happy-client-image" src="/img/pink-dot.svg" />
        <h4 className="hospital-hub-title">Hospital Hub: Stay Informed</h4>
      </div>
      <div className="video-out-wrapper">
        <Query url={BASE_URL + "/api/videos"}>
          {({ data }) => (
            <OwlCarousel
              options={carouselOptions}
              className="owl-carousel owl-theme all-video-slider nav-middle wow fadeInUp"
            >
              {data.map((i) => (
                <div
                  className="video-slider-outer"
                  onClick={() => onClickModal(i.videoId)}
                >
                  <div className="video-image-wrapper">
                    <img
                      className="video-slider-video"
                      // overlaySrc={`https://img.youtube.com/vi/${i.videoId}/2.jpg`}
                      src={`https://img.youtube.com/vi/${i.videoId}/0.jpg`}
                      alt={i.title}
                    ></img>
                    <img
                      className="video-play-button"
                      src="/img/Play-Button.svg"
                    />
                  </div>
                </div>
              ))}
            </OwlCarousel>
          )}
        </Query>
      </div>
      <div className="video-day-view-div">
        <button
          onMouseEnter={() => {
            handleMouseEnter("videoslider");
          }}
          onMouseLeave={handleMouseLeave}
          className="photo-day-view"
          onClick={()=> window.location.href = `https://www.youtube.com/@sabinehospital533/videos`}
        >
          View All
          <img src={
                      buttonId == "videoslider"
                        ? "/img/arrow-right-big.svg"
                        : "/img/arrow-right.svg"
                    } />
        </button>
      </div>
    </>
  );
};

export default VideoSlider;
